import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dcfe37cc&scoped=true&"
import script from "./index.component.ts?vue&type=script&lang=ts&"
export * from "./index.component.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=dcfe37cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfe37cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcfe37cc')) {
      api.createRecord('dcfe37cc', component.options)
    } else {
      api.reload('dcfe37cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dcfe37cc&scoped=true&", function () {
      api.rerender('dcfe37cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/Navbar/index.vue"
export default component.exports